export default "__VITE_ASSET__D3c7Iinu__"